(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alexia-home-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root = document) {
      root.querySelectorAll('[data-av2-tabs]').forEach(group => {
        if (group.dataset.ready) return;
        group.dataset.ready = 'true';
        const tabs = [...group.querySelectorAll('[data-av2-tab]')];
        const panels = [...group.querySelectorAll('[data-av2-panel]')];
        const collectionLinks = [...group.querySelectorAll('[data-av2-collection-link]')];
        group.querySelector('[data-av2-tablist]').setAttribute('role', 'tablist');
        function activate(index, focus = false) {
          tabs.forEach((tab, i) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', panels[i].id);
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].setAttribute('role', 'tabpanel');
            panels[i].tabIndex = 0;
            panels[i].hidden = i !== index;
          });
          collectionLinks.forEach(link => { link.hidden = link.dataset.av2CollectionLink !== panels[index].id; });
          if (focus) tabs[index].focus();
        }
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', event => { event.preventDefault(); activate(index); });
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (event.key === ' ') next = index;
            if (next !== undefined) { event.preventDefault(); activate(next, true); }
          });
        });
        if (tabs.length) activate(0);
      });
      const workshop = document.querySelector('[data-av2-workshop]');
      if (workshop) document.querySelectorAll('[data-av2-personalization]').forEach(link => { link.href = '#' + workshop.id; });
    }
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:block:select', event => { event.target.closest('[data-av2-tab]')?.click(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alexia-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openMenu = (index) => {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      if (desktop) {
        const details = Array.from(document.querySelectorAll('header-menu > details'));
        const target = details[index - 1];
        if (!target) return false;
        details.forEach((item) => {
          if (item !== target) item.removeAttribute('open');
        });
        if (!target.hasAttribute('open')) target.querySelector(':scope > summary')?.click();
        target.querySelector(':scope > summary')?.focus();
        return true;
      }

      const drawer = document.querySelector('#Details-menu-drawer-container');
      if (!drawer) return false;
      if (!drawer.hasAttribute('open')) drawer.querySelector(':scope > summary')?.click();
      window.setTimeout(() => {
        const submenus = Array.from(drawer.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li > details'));
        const target = submenus[index - 1];
        if (target && !target.hasAttribute('open')) target.querySelector(':scope > summary')?.click();
      }, 90);
      return true;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-alexia-open-menu]');
      if (!trigger) return;
      const index = Number(trigger.dataset.alexiaOpenMenu || 1);
      if (openMenu(index)) event.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
